import React from 'react';
import type { Quest } from '../../../../shared/CharacterTypes';
import { NpcQuestRewards } from '../../Systems/NPC/NpcQuestRewards';
import { questCardView } from '../../npc/hydrateNpcDialogue';

interface JournalRewardsProps {
  questId: string;
  /** The server's live rewards for an active or ready quest; a reference entry passes none. */
  live?: Quest['rewards'];
  referenceOnly: boolean;
  playerClass?: string;
}

/**
 * The journal's rewards, drawn by the codex's reward line (item tooltips, the ability a class learns,
 * a hidden ability kept hidden). An active or ready quest keeps the server's live XP, gold and items;
 * a completed or locked one shows the listed rewards for the character's class, marked as reference.
 */
export const JournalRewards: React.FC<JournalRewardsProps> = ({ questId, live, referenceOnly, playerClass }) => {
  const listed = questCardView(questId, undefined, playerClass);
  const view = listed && live && !referenceOnly ? {
    ...listed, rewardXP: live.xp, rewardGold: live.gold, rewardItems: [],
    rewardItemDetails: (live.items ?? []).map(item => ({ id: item.id, name: item.name, quantity: item.quantity })),
  } : listed;
  return <section className="quest-journal-rewards" aria-label={referenceOnly ? 'Authored reward information' : 'Quest reward information'}>
    {referenceOnly && <p>These are the quest’s listed rewards, not a history of what you received.</p>}
    {view
      ? <NpcQuestRewards quest={view} label={referenceOnly ? 'Listed rewards · for reference' : 'Quest rewards'} />
      : <p>Reward information is unavailable.</p>}
  </section>;
};
